<div class="main-Content d-flex">
  <h3>Create New Ticket</h3>
  <div class="container-fluid d-flex flex-column mat-table elevation flex-1 px-5 py-5">
    <div class="row">
      <div class="col-md-8 left-sec">
        <form [formGroup]="ticketForm" autocomplete="off" (ngSubmit)="onSubmit()">
          <div class="d-flex ">
            <div class="col-sm-12">
              <div class="form-group row">
                <div class="col-sm-12">
                  <label> Products <span style="color: #ff232382;">*</span></label>
                  <select class="form-control" formControlName="product" [(ngModel)]="selectedProductId" (change)="onProductSelection()" required>
                    <option value="undefined">Select Product</option>
                    <option *ngFor="let product of products" [value]="product.productID">
                      {{product.productName}}
                    </option>
                  </select>
                  <label class="text-danger" *ngIf="hasError('product', 'required') && submitted">Product is required.</label>
                </div>                
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label>Problems<span style="color: #ff232382;">*</span> </label>
                  <select class="form-control" formControlName="problem" [(ngModel)]="selectedProblemId" (change)="onProblemSelection()" required>
                    <option value="undefined">Select Problem</option>
                    <option *ngFor="let problem of problems" [value]="problem.problemID">
                      {{problem.problemName}}
                    </option>
                  </select>
                  <label class="text-danger" *ngIf="hasError('problem', 'required') && submitted">Problem is required.</label>
                </div>                     
              </div>
              <div class="form-group row">
                <div class="col-sm-4">
                  <label>Impact<span style="color: #ff232382;">*</span> </label>
                  <select class="form-control" formControlName="impact" [(ngModel)]="selectedImpactId"  required>
                    <option value="undefined">Select Impact</option>
                    <option *ngFor="let impact of impacts" [value]="impact.impactID">
                      {{impact.impactName}}
                    </option>
                  </select>
                  <label class="text-danger" *ngIf="hasError('impact', 'required') && submitted">Impact is required.</label>
                </div>
                <div class="col-sm-4">
                  <label>Contact<span style="color: #ff232382;">*</span> </label>
                  <input type="text" class="form-control" maxlength="10"  autocomplete="off" placeholder="Mobile Number"
                  formControlName="contact" id="contact"/>
                  <label class="text-danger" *ngIf="hasError('contact', 'required') && submitted">Mobile is required.</label>
                  <label class="text-danger"
                       *ngIf="ticketForm.get('contact').touched && ticketForm.get('contact').errors?.pattern">Please, Enter
                       10 digit Mobile Number.
                </label>  
                </div>
                <div class="col-sm-4">
                  <label>Email ID<span style="color: #ff232382;">*</span> </label>
                  <input type="text" class="form-control" maxlength="200"  autocomplete="off" placeholder="Email Address"
                  formControlName="email" id="email"/>
                  <label class="text-danger" *ngIf="hasError('email', 'required') && submitted">Email Address is required.</label>
                  <label class="text-danger"
                  *ngIf="ticketForm.get('email').touched && ticketForm.get('email').errors?.email">Please enter valid
                  email Id.</label>
                </div>
              </div>              
            </div>
            <!-- <div class="col-sm-2 divider"></div> -->
     
          </div>
          <div class="col-sm-12">
            <label style="color: #dbdbdb;">Detailed Description<span style="color: #ff232382;">*</span></label>
            <textarea class="form-control" formControlName="descripition" name="descripition" style="margin-top: 0px;margin-bottom: 0px;height: 150px;">
            </textarea>
            <label class="text-danger" *ngIf="hasError('descripition', 'required') && submitted">Description is required.</label>                                     
          </div>
        </form>
      </div>
      <div class="col-md-4 d-flex">
        <div class="d-flex upload-wrap">
          <mat-card style="margin-top: -30px !important; width: 100%;box-shadow: none;background-color: transparent;">
            <mat-card-content>
              <ul>
                <li *ngFor="let file of files ; let i = index" style="padding-bottom: 10px;">
                  <span style="margin-top: 5px;color: #ededed;">{{file.data.name.toUpperCase()}} <span class="pull-right" style="font-size: 20px;" (click)="RemoveAttachedFile(i)"> <i class="fa fa-times-circle" aria-hidden="true"></i></span></span>
                  &nbsp;
                  <mat-progress-bar [value]="file.progress"></mat-progress-bar>
                  <span id="file-label"></span>
                </li>
              </ul>
            </mat-card-content>
            <mat-card-actions *ngIf="!isMaxFileCountReached" class="text-center">
              <button class="btn btn-close d-flex" (click)="onUploadClick()" style="margin: auto;">
                <mat-icon>file_upload</mat-icon>
                Upload
              </button>
            </mat-card-actions>
          </mat-card>
          <input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" accept="image/*"
            style="display:none;" />
        </div>

      </div>
    </div>
    <div class="mt-3 text-center" >
      <button type="button"  (click)="onClose()" class="btn btn-close px-4 mt-3">Close</button>&nbsp;&nbsp;&nbsp;
      <button type="button"  (click)="onSubmit()" class="btn btn-ok px-4 mt-3">
        <span *ngIf="loading && submitted"  style="border-width:0.1em !important;" class="spinner-border spinner-border-sm mr-2"></span>Create Ticket</button>&nbsp;
      
    </div>
  </div>
</div>